import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { formatDateTime } from "../utils/date.js";
const TextWrapper = styled(Box)(({
  theme
}) => ({
  maxWidth: "20rem",
  overflow: "hidden",
  textOverflow: "ellipsis",
  padding: theme.sizes.spacing.none
}));
const Text = styled(Typography)(({
  theme
}) => ({
  color: theme.colors.text.primary,
  fontSize: theme.fonts.size.sm,
  fontFamily: theme.fonts.family.body,
  fontWeight: theme.fonts.weight.normal,
  lineHeight: theme.fonts.lineHeight["leading-5"],
  letterSpacing: theme.fonts.letterSpacing.wide
}));
const CellDateTime = (t0) => {
  const $ = c(9);
  const {
    columnType,
    value,
    display,
    format,
    locale
  } = t0;
  if (value === null || isNaN(value)) {
    let t12;
    if ($[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
      t12 = /* @__PURE__ */ jsx(TextWrapper, { children: /* @__PURE__ */ jsx(Text, { noWrap: true, variant: "valueCell", children: "—" }) });
      $[0] = t12;
    } else {
      t12 = $[0];
    }
    return t12;
  }
  let t1;
  if ($[1] !== columnType || $[2] !== display || $[3] !== format || $[4] !== locale || $[5] !== value) {
    t1 = columnType === "duration" ? formatDateTime({
      value: Math.trunc(value),
      type: columnType,
      display
    }) : formatDateTime({
      value,
      type: columnType,
      display,
      format,
      locale
    });
    $[1] = columnType;
    $[2] = display;
    $[3] = format;
    $[4] = locale;
    $[5] = value;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const formattedValue = t1;
  let t2;
  if ($[7] !== formattedValue) {
    t2 = /* @__PURE__ */ jsx(TextWrapper, { children: /* @__PURE__ */ jsx(Text, { noWrap: true, variant: "valueCell", children: formattedValue }) });
    $[7] = formattedValue;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
export {
  CellDateTime as default
};
